// Root route: typed router context (query client, auth), the toast host, and the app-wide not-found page.
import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";

import { NotFoundPage } from "@/app/shell/RouteStates";
import { Toaster } from "@/components/ui/sonner";
import type { RouterContext } from "@/router";

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
  notFoundComponent: NotFoundPage,
});

function RootLayout() {
  return (
    <>
      <Outlet />
      <Toaster />
    </>
  );
}
